<script>
import { loop_guard } from "svelte/internal";


	//import "minimal-table.css";

	let searchResults = Promise.resolve([]);
	let help = false;

	async function search(text, key) {

		const result = await fetch("/api/search", {
			method: "POST",
			body: JSON.stringify({ search: text, key: key })
		});

		if (!result.ok) {
			throw new Error(result.statusText);
		}

		const jsonResult = await result.json();

		return jsonResult;
	}

	function onSubmit(event) {
		const data = new FormData(event.currentTarget)
		if (data.get("search-term") === "hjelp" || data.get("search-term") === "Hjelp") {
			alert("https://youtu.be/ciNHn38EyRc \n Men bruk \"null\" for å fylle opp til riktig antall kolonner i stedet for et tilfeldig tall som de gjør")
		} else {
			searchResults = search(data.get("search-term"), data.get("key"));
		}
	}
</script>

<main>
	<div class="img_wrapper">
		<img src="Logo_egg.jpg" alt="Varelager logo-egg" class="imgLogoEgg"/>
		<img src="Logo.jpg" alt="Varelager logo" class="imgLogo"/>
	</div>
	<p>
		Velkommen til vårt nye varelager!
		<br/>
		For litt info om hvordan varelageret funker, så trykk på infoknappen.
	</p>
	<div class="center">
		<button on:click={() => {help=!help;}}>Info</button>
	</div>
	{#if help}
	<p class="info">
		Vi har skaffet oss en super database for å holde oversikt over hele varelageret vårt.
		Databasen består av 6 kolonner: id, navn, antall,..., og så er det rad etter rad med varer 🎁🎄. <br/>
		Alvenes utviklingsteam (AUT) har i første omgang sørget for å skille ut varelageret fra resten av systemet 
		i en tabell de kaller <em>ting</em> i skjema <em>vi</em>, der <em>i</em> er versjonsnummeret. 
		Dette er gjort for å være sikker på at alt funker som det skal før det integreres sammen med resten av systemene.
		<br/>
		AUT har satt opp varelageret så når du søker etter noe så sendes spørringen direkte til databasen, og svaret
		sendes tilbake til tabellen nedenfor, der de fire kolonnene navn, antall, enhet og kommentar vises.
	</p>
	
	{/if}
	<form on:submit|preventDefault={onSubmit} autocomplete="off">
		<div style="display: table-row;">
			<label for="API-key">Programmeringsgrensesnittnøkkel:</label>
			<input id="API-key" type="text" name="key"/>
		</div>
		<br/>
		<div style="display: table-row;">
			<label for="search-term">Søkeord: </label>
			<input id="search-term" type="text" name="search-term"/>
		</div>
		<br/>
		<button type="submit">Varelager Søk</button>
	</form>

	{#await searchResults}
		<p>Laster...⏳</p>
	{:then results}
		{#if results.length > 0}
			<table>
				<tr>
					<th>Navn</th>
					<th>Antall</th>
					<th>Enhet</th>
					<th>Kommentar</th>
				</tr>
				{#each results as result}
					<tr>
						<td>{result.navn}</td>
						<td>{result.antall}</td>
						<td>{result.enhet}</td>
						<td>{result.kommentar}</td>
					</tr>
				{/each}
			</table>
		{/if}
	{:catch error}
		<p>{error}</p>
	{/await}
</main>

<style>
	.center {
		display: block;
		margin-left: auto;
		margin-right: auto;
	}

	.img_wrapper {
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		width: 25rem;
	}

	.imgLogo {
		position: relative;
		width: 100%;
		display: block;
		margin: auto;
		z-index: 3;
	}

	.imgLogoEgg {
		position: absolute;
		width: 100%;
		margin-left: auto;
		margin-right: auto;
		z-index: 1;
	}

	form {
		display: table;
		width: 50%;
		margin-left: auto;
		margin-right: auto;
		text-align: center;
		font-family: 'Times New Roman', Times, serif;
		text-align: center;
	}

	label {
		display: table-row;
		text-align: right;
	}

	input {
		font-family: 'Times New Roman', Times, serif;
		font-size: 14px;
		height: 20px;
		width: 100%;
		box-shadow: inset 1px 1px #6b6b6b, inset -1px -1px #ffffff, inset 2px 2px #000000, inset -2px -2px #8f8f8f;
		border-width: 0px;
		margin-bottom: 5px;
		margin-top: 5px;
		padding: 2px;
		display: table-row;
	}

	input:focus {
    	outline-width: 0;
	}

	input::content {
		font-family: 'Times New Roman', Times, serif;
	}

	button {
		font-family: 'Times New Roman', Times, serif;
		font-size: 14px;
		background: silver;
		box-shadow: inset -1px -1px #0a0a0a, inset 1px 1px #ffffff, inset -2px -2px grey, inset 2px 2px #dfdfdf;
		border-width: 0px;
		padding-top: 4px;
		padding-bottom: 4px;
		padding-left: 35px;
		padding-right: 35px;
		margin-bottom: 15px;
	}

	p {
		font-family: 'Times New Roman';
		text-align: center;
	}

	p.info {
		padding-left: 20%;
		padding-right: 20%;
		font-size: 0.8rem;
	}

	div.center {
		text-align: center;
	}

	:root {
		font-family: monospace, "apple color emoji", "segoe ui emoji",
			"noto color emoji", "android emoji", "emojisymbols", "emojione mozilla",
			"twemoji mozilla", "segoe ui symbol";
		font-size: 18px;
	}
	
	table {
		border-collapse: collapse;
		border: 2px solid rgb(200, 200, 200);
		letter-spacing: 1px;
		font-family: Pixelated;
		font-size: 0.8rem;
		margin-left: auto;
		margin-right: auto;
		margin-top: 20px;
	}
	
	td, th {
		border: 1px solid rgb(190,190,190);
		padding: 10px 20px;
	}
	
	th {
		background-color: rgb(235,235,235);
	}
	
	td {
		text-align: center;
	}
	
	tr:nth-child(even) td {
		background-color: rgb(250,250,250);
	}
	
	tr:nth-child(odd) td {
		background-color: rgb(245,245,245);
	}
</style>